import React, {Component} from 'react';
import {showAxiosError} from "../../util/Helpers";
import Alert from "react-s-alert";
import '../memberList/MemberList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {UncontrolledTooltip} from "reactstrap";
import Select from "../../local_node_modules/react-select";
import {DatePicker, Form, input} from "antd";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import Maskedinput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

class EditMemberAccrualModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false,
            isLoading: false,
            searching: false,
            searchQuery: undefined,
            selectedMember: null,
            accrual: {
                id: null,
                accrualDate: null,
                accrualDueDate: null,
                amount: null,
                relatedYear: null,
                accrualType: null,
                memberId: null,
                branchId: null,
            },
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            isOpen: false,
        };

        this.addAccrual = this.addAccrual.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeAccrualDate = this.onChangeAccrualDate.bind(this);
        this.onChangeAccrual = this.onChangeAccrual.bind(this);
        this.onChangeAmount = this.onChangeAmount.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);

    }

    componentDidMount() {
        let selectedAccrual = this.props.selectedAccrual;
        let mode = this.props.mode;
        if (selectedAccrual && mode === 'edit') {
            selectedAccrual.accrualDate = (selectedAccrual.accrualDate !== null) ? moment.utc(selectedAccrual.accrualDate, "YYYY-MM-DD HH:mm:ss") : null;
            selectedAccrual.accrualDueDate = (selectedAccrual.accrualDueDate !== null) ? moment.utc(selectedAccrual.accrualDueDate, "YYYY-MM-DD HH:mm:ss") : null;
            this.setState({accrual: selectedAccrual});
        }
        this.getMember();
    }

    getMember = () => {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + this.props.memberId,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let selectedMember = response.data;
                self.setState({
                    selectedMember,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    };

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        console.log("e", e);
        console.log("rule, boundary, value:", rule, boundary, value);
        let result = validateField(rule, boundary, value);
        console.log("result:", result);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        console.log("error:", error);
        this.setState({error});
    }

    addAccrual() {
        let self = this;
        let validity = this.validateComponent();

        if (validity.valid) {
            if (self.state.selectedMember) {
                let accrual = self.state.accrual;
                accrual.memberId = self.props.memberId;
                accrual.branchId = self.state.selectedMember.city.odaId;
                accrual.branch = self.state.selectedMember.city.oda;
                accrual.amount = accrual.amount.toString().replace(',', '.');
                self.setState({accrual});
            }
            let params = {
                url: API_BASE_URL + "/accrual/",
                data: self.state.accrual,
                method: self.state.accrual.id ? "patch" : "post",
            };
            request(params)
                .then(() => {
                    self.state.accrual.id ? Alert.success(
                        "Aidat güncellendi.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 5000
                        }) : Alert.success(
                        "Aidat kaydedildi.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 5000
                        });
                    self.cancelProcess();
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            let message = 'Hatalı veya eksik alanlar var!';
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    handleEdit(item) {
        let self = this;
        self.setState({
            selectedAccrual: item,
            isOpen: true
        });
    }


    onChangeAccrualDate(name, value) {
        let accrual = this.state.accrual;
        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        accrual[name] = value;
        this.setState({accrual});
    }

    onChangeAccrual(e) {
        this.setState({
            accrual: {
                ...this.state.accrual,
                [e.target.name]: e.target.value.toString().toLocaleUpperCase()
            }
        })
    }

    onChangeAmount(e) {
        this.setState({
            accrual: {
                ...this.state.accrual,
                [e.target.name]: e.target.value.toString().trim().substring(0, e.target.value.length - 2)
            }
        })
    }


    onSelectChange(name, value) {
        let accrual = this.state.accrual;
        if (value === null) {
            accrual[name] = null
        } else {
            accrual[name] = value.value;
        }
        this.setState({accrual});
    }

    cancelProcess() {
        let accrual = {
            id: null,
            accrualDate: null,
            accrualDueDate: null,
            amount: null,
            relatedYear: null,
            accrualType: null,
            memberId: null,
            branchId: null,
        };
        this.setState({accrual});
        this.props.cancelProcess();
    }

    render() {
        const accrualTypes = [
            {value: "RegistrationFee", label: "Oda Giriş Aidatı"},
            {value: "YearlyFee", label: "Yıllık Aidat"},
        ];

        const numberMask = createNumberMask({
            prefix: '',
            suffix: ' ₺',
            allowDecimal: true,
            decimalSymbol: ',',
            includeThousandsSeparator: false,
        });

        let tAccrualDate = this.state.accrual.accrualDate ? {value: this.state.accrual.accrualDate} : {};
        let tAccrualDueDate = this.state.accrual.accrualDueDate ? {value: this.state.accrual.accrualDueDate} : {};

        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header "/>
                    <div className="card-body mt-1">
                        <Form>
                            <div className="card-body mt-1">
                                <div className="FormRenk col-sm-12">
                                    <div className="col-sm-12 row">
                                        <div className="col-sm-3">
                                            <label>Tahakkuk Tipi: *</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={"form-group" + this.validateClass('tAccrualType')}>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Tahakkuk tipi seçiniz."
                                                    isClearable={false}
                                                    isSearchable={true}
                                                    name="accrualType"
                                                    id="tAccrualType"
                                                    ref="tAccrualType"
                                                    inputProps={{'vdata': "required"}}
                                                    options={accrualTypes}
                                                    onChange={(value) => this.onSelectChange("accrualType", value)}
                                                    value={this.state.accrual.accrualType}/>
                                                {this.validateMessage('tAccrualType') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tAccrualType" delay={0}>
                                                    {this.validateMessage("tAccrualType")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3">
                                            <label>Dönem: *</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={"form-group" + this.validateClass('tRelatedYear')}>
                                                <input className="form-control"
                                                       type="text"
                                                       name="relatedYear"
                                                       id="tRelatedYear"
                                                       data-vlength="1,50"
                                                       onBlur={this.validateField}
                                                       ref="tRelatedYear"
                                                       value={this.state.accrual.relatedYear}
                                                       onChange={(e) => this.onChangeAccrual(e)}
                                                />
                                                {this.validateMessage('tRelatedYear') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tRelatedYear" delay={0}>
                                                    {this.validateMessage("tRelatedYear")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3">
                                            <label>Tutar: *</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={"form-group" + this.validateClass('tAmount')}>
                                                <Maskedinput className="form-control"
                                                             mask={numberMask}
                                                             type="text"
                                                             name={"amount"}
                                                             id={"tAmount"}
                                                             inputProps={{vdata: "required", vlength: '3,12'}}
                                                             placeholder="________,__₺"
                                                             onBlur={this.validateField}
                                                             ref={"tAmount"}
                                                             value={this.state.accrual.amount && this.state.accrual.amount.toString().replace('.', ',') + ' ₺'}
                                                             onChange={(e) => this.onChangeAmount(e)}
                                                />
                                                {this.validateMessage('tAmount') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tAmount" delay={0}>
                                                    {this.validateMessage("tAmount")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3">
                                            <label>Aidat Oluşturma Tarihi: *</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={"form-group" + this.validateClass('tAccrualDate')}>
                                                <DatePicker {...tAccrualDate}
                                                            className="basic-single"
                                                            placeholder="Tarih seçiniz."
                                                            classNamePrefix="select"
                                                            format="DD.MM.YYYY"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="accrualDate"
                                                            id="tAccrualDate"
                                                            ref="tAccrualDate"
                                                            style={{width: 160}}
                                                            inputProps={{'vdata': "required"}}
                                                            onChange={(date) => this.onChangeAccrualDate("accrualDate", date)}/>
                                                {this.validateMessage('tAccrualDate') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tAccrualDate" delay={0}>
                                                    {this.validateMessage("tAccrualDate")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3">
                                            <label>Son Ödeme Tarihi: *</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={"form-group" + this.validateClass('tAccrualDueDate')}>
                                                <DatePicker {...tAccrualDueDate}
                                                            className="basic-single"
                                                            placeholder="Tarih seçiniz."
                                                            classNamePrefix="select"
                                                            format="DD.MM.YYYY"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="accrualDueDate"
                                                            id="tAccrualDueDate"
                                                            ref="tAccrualDueDate"
                                                            style={{width: 160}}
                                                            inputProps={{'vdata': "required"}}
                                                            onChange={(date) => this.onChangeAccrualDate("accrualDueDate", date)}/>
                                                {this.validateMessage('tAccrualDueDate') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tAccrualDueDate"
                                                                     delay={0}>
                                                    {this.validateMessage("tAccrualDueDate")}
                                                </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                    <div className="modal-footer">
                        <div className='col-sm-12 row' id="deleteModal">
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={this.cancelProcess}>
                                    İptal Et
                                </button>
                            </div>
                            <div className="col-sm-8"/>
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        onClick={() => this.addAccrual()}>
                                    Kaydet
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default EditMemberAccrualModal


// WEBPACK FOOTER //
// ./src/page/memberList/EditMemberAccrualModal.js